const getMonthKey = () => {
  return [
    'label.months-0',
    'label.months-1',
    'label.months-2',
    'label.months-3',
    'label.months-4',
    'label.months-5',
    'label.months-6',
    'label.months-7',
    'label.months-8',
    'label.months-9',
    'label.months-10',
    'label.months-11'
  ]
}

const getDayKey = () => {
  return [
    'label.weekdays-letter-0',
    'label.weekdays-letter-1',
    'label.weekdays-letter-2',
    'label.weekdays-letter-3',
    'label.weekdays-letter-4',
    'label.weekdays-letter-5',
    'label.weekdays-letter-6'
  ]
}

const getTooltipWeekDayKey = () => {
  return [
    'label.weekdays-0',
    'label.weekdays-1',
    'label.weekdays-2',
    'label.weekdays-3',
    'label.weekdays-4',
    'label.weekdays-5',
    'label.weekdays-6'
  ]
}

export const getTranslatedMonth = callback => getMonthKey().map(key => callback(key).toUpperCase())
export const getTranslatedDay = callback => getDayKey().map(key => callback(key).toUpperCase())
export const getTranslatedWeekDay = callback => getTooltipWeekDayKey().map(key => callback(key))
